import { wlsly } from 'helpers/wlsly'
import { type AccountWithUser } from '../../../../dist/api'

const createResponse = (body: unknown) =>
  new Response(JSON.stringify(body), {
    status: 200,
    statusText: 'OK',
    headers: {
      'Content-Type': 'application/json',
    },
  })

export const userHandler = (request: Request) => {
  if (request.url.includes('accounts/profile')) {
    const userState = wlsly()?.initialState?.currentAccount
    const isAccountUserState = !!(userState as unknown as AccountWithUser)
      ?.selectedUserId //TODO: Backend inject wrong state(UserFull), we need AccountWithUser, after fix - remove this check

    return isAccountUserState && createResponse(userState)
  }
}
